import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Flex, Form, Image, Row, Typography } from 'antd'
import { MyInput, MySelect, MySingleFileUpload } from '../../PageComponents'
import { Link } from 'react-router-dom'
import { skills } from '../../../shared'
import { Breadcrumb } from '../../Breadcrumb'
import { apiCalls } from '../../../shared/Apis'

const { Title, Text } = Typography
const ApplyJobForm = ({jobid}) => {
    const [form] = Form.useForm();
    const [ loading, setLoading ] = useState(false)  
    const [ servicelookup, setServiceLookup ] = useState([])

    const jobApplication = async () => {
        setLoading(true);
        let data = form.getFieldsValue()
        console.log(data)
        const formdata = new FormData()
        formdata.append("firstName",  data?.firstName)
        formdata.append("lastName", data?.lastName)
        formdata.append("email", data?.email)
        formdata.append("contactNumber", data?.contactNumber)
        formdata.append("address", data?.address)
        formdata.append("city", data?.city)
        formdata.append("country", data?.country)
        formdata.append("experience", data?.experience)
        formdata.append("message", data?.message)
        formdata.append('jobID',jobid)
        const servicesIDArray = data?.servicesID || [];
        const formattedServicesID = JSON.stringify(servicesIDArray);
        formdata.append("servicesID", formattedServicesID);
        if(data?.cv)
            formdata.append("cv", data?.cv)
        let result= await apiCalls?.jobApplicationApi?.sendJobApplication(formdata)
        setLoading(false)
        if(result)
            form.resetFields()
    }

    useEffect(()=>{
            getService()
        },[])
    
        const getService = async () => {
            let result= await apiCalls?.serviceApi?.getService()
            if(result)
            setServiceLookup(result)
        }
    

  return (
    <div>
        <Breadcrumb title='Apply for a Pro' pageName='Pro' breadcrumb={[{to:'/',name:'Home'}]}/>
        <div className='container padding-t'>   
            <Row gutter={[24,24]} className='mbl-reverse'>
                <Col lg={{span: 15}} md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                    <Card className='bg-transparent border0 shadow rounded'> 
                        <Flex vertical gap={40}>
                            <Flex vertical gap={10}>
                                <Title level={1} className='m-0 gradient-text'>
                                    Apply for a pro
                                </Title>
                                <Text className='text-gray'>
                                    Fill the form below accurately indicating your potentials and suitability to pro applying for.
                                </Text>
                            </Flex> 
                            <Form 
                                form={form}
                                layout='vertical'
                                onFinish={jobApplication}
                            >
                                <Row gutter={[16, 16]} justify={'center'}>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                                        <MyInput 
                                            label='First Name'
                                            name='firstName'
                                            required
                                            message='Please enter first name'
                                            placeholder=''
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                                        <MyInput 
                                            label='Last Name'
                                            name='lastName'
                                            required
                                            message='Please enter last name'
                                            placeholder=''
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <MyInput 
                                            label='Email'
                                            name='email'
                                            required
                                            message='Please enter email'
                                            placeholder=''
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                        <MyInput 
                                            label='Contact number'
                                            name='contactNumber'
                                            type='number'
                                            required
                                            message='Please enter contact number'
                                            placeholder=''
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                        <MyInput 
                                            label='Address'
                                            name='address'
                                            required
                                            message='Please enter address'
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                        <MyInput 
                                            label='City'
                                            name='city'
                                            required
                                            message='Please enter city'
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                        <MyInput 
                                            label='Country'
                                            name='country'
                                            required
                                            message='Please enter country'
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                        <MySelect 
                                            label='Services'
                                            name='servicesID'
                                            mode={'tags'}
                                            required
                                            message='Please choose service'
                                            placeholder=''
                                            options={servicelookup}
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                        <MyInput 
                                            label='Experience'
                                            name='experience'
                                            required
                                            message='Please enter experience'
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <MySingleFileUpload
                                            name='cv'
                                            label='Upload CV (pdf)'
                                            required
                                            message='please upload your cv'
                                            form={form}
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                        <MyInput 
                                            textArea
                                            label='Message'
                                            name='message'
                                            required
                                            message='Please enter message'
                                            autoSize={{ minRows: 8, maxRows: 10 }}
                                            placeholder='Write your message here'
                                        />
                                    </Col>
                                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 7 }}>
                                        <Flex>
                                            <Button 
                                                className="btn rounded" 
                                                block
                                                htmlType='submit'
                                                loading={loading}
                                            >
                                                Submit
                                            </Button>
                                        </Flex>
                                    </Col>
                                </Row>
                            </Form>
                        </Flex>
                    </Card>
                </Col>
                <Col lg={{span: 9}} md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                    <Flex vertical gap={0} align='center' className='mt-3'>
                        <Title className='gradient-text'>Join Us !</Title>
                        <Image src="/assets/images/form-1.png" alt="Nextdoor Pros" preview={false} />
                        <Flex className='mt-3' gap={20}>
                            <Link to={'/'}>
                                <Image src='/assets/icons/twitter.png' width={'30px'} preview={false} />
                            </Link>
                            <Link to={'/'}>
                                <Image src='/assets/icons/facebook.png' width={'30px'} preview={false} />
                            </Link>
                            <Link to={'/'}>
                                <Image src='/assets/icons/linkedin.png' width={'30px'} preview={false} />
                            </Link>
                            <Link to={'/'}>
                                <Image src='/assets/icons/insta.png' width={'30px'} preview={false} />
                            </Link>
                        </Flex>
                    </Flex>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export {ApplyJobForm}